import React, { useState, useMemo } from 'react';

function interpolateColor(t) {
  // 0 = deep indigo, 0.5 = purple, 1.0 = bright green
  const r = t < 0.5 ? Math.round(30 + t * 2 * 69)  : Math.round(99 - (t - 0.5) * 2 * 25);
  const g = t < 0.5 ? Math.round(27 + t * 2 * 75)  : Math.round(102 + (t - 0.5) * 2 * 71);
  const b = t < 0.5 ? Math.round(75 + t * 2 * 166) : Math.round(241 - (t - 0.5) * 2 * 113);
  return `rgb(${r}, ${g}, ${b})`;
}

export default function HeatmapTab({ game, freq, bonusFreq }) {
  const [view, setView] = useState('main');

  const currentFreq = view === 'main' ? freq : bonusFreq;
  const maxNum = view === 'main' ? game.maxMain : game.maxBonus;

  const { minF, maxF } = useMemo(() => {
    const vals = Object.values(currentFreq).filter(v => v !== undefined);
    if (!vals.length) return { minF: 0, maxF: 1 };
    return { minF: Math.min(...vals), maxF: Math.max(...vals) };
  }, [currentFreq]);

  const range = maxF - minF || 1;

  return (
    <>
      <div className="sub-toggle">
        <button className={`mode-btn ${view === 'main' ? 'active' : ''}`} onClick={() => setView('main')}>
          Main balls
        </button>
        <button className={`mode-btn ${view === 'bonus' ? 'active' : ''}`} onClick={() => setView('bonus')}>
          {game.bonusName}
        </button>
      </div>

      <p className="section-label">Frequency heatmap (1-{maxNum})</p>

      <div className="heatmap-legend">
        <span className="heatmap-legend-label">Less</span>
        <div className="heatmap-legend-bar"></div>
        <span className="heatmap-legend-label">More</span>
      </div>

      <div className="heatmap-grid">
        {Array.from({ length: maxNum }, (_, i) => i + 1).map((n) => {
          const f = currentFreq[n] || 0;
          const t = (f - minF) / range;
          return (
            <div
              key={n}
              className="heatmap-cell"
              style={{ backgroundColor: interpolateColor(t) }}
              title={`Ball #${n}: drawn ${f} times`}
            >
              <span className="heatmap-num">{n}</span>
              <span className="heatmap-count">{f}</span>
            </div>
          );
        })}
      </div>
    </>
  );
}
